module.exports = __webpack_public_path__ + "static/media/22ESCWA5.f9bcb396.jpg";